import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TestimonialBox } from '../components/TestimonialBox';
import { ProductSidebar } from '../components/ProductSidebar';
import { CTASection } from '../components/CTASection';
import { StickyBottomBar } from '../components/StickyBottomBar';
export function AdvertorialPage() {
  const testimonials = [{
    author: 'Sarah M., 44',
    location: 'Austin, TX',
    quote: 'After 12 years of nightly wine, I stopped wanting it in week one. Week one. My husband says he has his wife back. I say I have myself back.'
  }, {
    author: 'Jennifer K., 39',
    location: 'Denver, CO',
    quote: "The 3 AM wake-ups were destroying me. I'd lie there in panic for hours. Now I sleep through the night. My anxiety is just... gone. I can't believe something so simple worked when therapy didn't."
  }, {
    author: 'Michelle R., 52',
    location: 'Portland, OR',
    quote: "I spent over $6,000 on therapy trying to quit. This patch did what 18 months of therapy couldn't—it calmed my nervous system down. Within 10 days the craving went from a 9 to a 2."
  }, {
    author: 'Rachel T., 36',
    location: 'Charlotte, NC',
    quote: "I can finally be the mom I wanted to be. Present at bedtime. Patient when my kids need me. Proud of who I am. I didn't know life could feel this calm."
  }, {
    author: 'Lisa W., 48',
    location: 'Seattle, WA',
    quote: "I tried AA, naltrexone, supplements, everything. Nothing worked. This patch was the first thing that actually addressed WHY I was drinking—my nervous system was fried. Two weeks in and I'm a different person."
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-128">
      <Header data-id="element-129" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-130">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-131">
          {/* Main Content Column */}
          <article className="w-full lg:w-[65%]" data-id="element-132">
            <Hero data-id="element-133" />

            {/* IMAGE 1: Emotional disconnection at breakfast - RIGHT AFTER HEADLINE */}
            <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/hpZoyrKXNKJ1EcCdKC7wkN/ChatGPT_Image_10_Ιαν_2026,_11_55_32_π.μ..png" alt="Mother sitting at kitchen table with coffee looking defeated, daughter with headphones in background not looking at her, wine bottles visible" className="w-full h-auto rounded-lg" data-id="element-135" />
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 font-serif leading-relaxed" data-id="element-136">
              <p className="text-xl mb-6 font-semibold text-gray-900" data-id="element-137">
                I still remember that Tuesday morning like it was yesterday.
              </p>

              <p className="mb-6" data-id="element-138">
                I walked into the kitchen at 7:15 AM, head pounding, mouth dry
                as sandpaper. My 14-year-old daughter Emma was already at the
                table, headphones in, staring at her cereal bowl.
              </p>

              <p className="mb-6" data-id="element-139">
                She didn't look up when I sat down. She didn't look up when I
                poured my coffee. She didn't look up at all.
              </p>

              <p className="mb-6" data-id="element-140">And I knew. She knew.</p>

              <p className="mb-8" data-id="element-141">
                That crushing, hollow feeling in my chest wasn't just a
                hangover. It was the weight of watching my daughter pull away
                from me, one morning at a time, because she was tired of seeing
                me like this.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-142">
                The Nightly Cycle I Couldn't Break
              </h2>

              <p className="mb-6" data-id="element-143">
                It happened the same way every single night.
              </p>

              <p className="mb-6" data-id="element-144">
                I'd wake up that morning with the familiar shame hangover—the
                physical pain mixed with the emotional torture of broken
                promises. I'd stand in the shower letting the water run over me,
                making the same vow I'd made hundreds of times before: "Not
                tonight. Tonight I'm different."
              </p>

              <p className="mb-6" data-id="element-145">And I meant it. I really did.</p>

              <p className="mb-6" data-id="element-146">
                I'd make it through the workday. Get through the afternoon.
                Start making dinner with actual determination to stay in
                control.
              </p>

              <p className="mb-6" data-id="element-147">Then 7 PM would roll around.</p>

              <p className="mb-6" data-id="element-148">
                That's when it would hit. That screaming urge that started in my
                chest and spread through my entire body. The mental noise that
                drowned out everything else: "Just one glass. You've earned it.
                You've been good all day. Just one won't hurt."
              </p>

              <p className="mb-6" data-id="element-149">
                One glass turned into two. Two turned into "I'll just finish
                this bottle." Before I knew it, I was opening a second bottle
                and the night became a blur.
              </p>

              {/* IMAGE 2: Wine bottles and the nightly ritual */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-150">
                <img src="https://cdn.magicpatterns.com/uploads/nrKnszkQKZbSsztMMBA8WE/ChatGPT_Image_10_Ιαν_2026,_11_55_30_π.μ..png" alt="Kitchen counter at 7 PM with wine bottles and glass, woman's hands opening another bottle" className="w-full h-auto rounded-lg" data-id="element-151" />
              </div>

              <p className="mb-8" data-id="element-152">
                The worst part? I'd wake up at 3 AM in a panic—heart racing,
                sheets drenched in sweat, replaying conversations I couldn't
                fully remember. Did I say something awful to my husband? Was I
                slurring when Emma asked me to help with homework?
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-153">
                The anxiety was crushing. The shame was unbearable.
              </p>

              <p className="mb-8" data-id="element-154">
                And the next morning, the cycle would start all over again.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-155">
                I Tried Everything (And Failed at All of It)
              </h2>

              <p className="mb-6" data-id="element-156">
                If you're reading this, you've probably tried some of these too.
              </p>

              <p className="mb-6" data-id="element-157">
                I made rules. Only on weekends. Only two glasses. Only after 8
                PM. I'd follow them for three days, maybe a week, then break
                them. The guilt from breaking my own rules only made me drink
                more.
              </p>

              <p className="mb-6" data-id="element-158">
                I downloaded apps that tracked my drinks. They just made me feel
                like a prisoner. I'd look at my phone, see the counter, and feel
                worse about myself. Eventually, I just stopped logging.
              </p>

              <p className="mb-6" data-id="element-159">
                I went to therapy for eight months. My therapist was kind. We
                talked about my childhood, my stress, my perfectionism. But
                every session ended the same way—I'd leave feeling slightly
                better, then drink that night anyway.
              </p>

              {/* IMAGE 3: Failed attempts - therapy, apps, supplements */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-160">
                <img src="https://cdn.magicpatterns.com/uploads/sQA8uibMb87JX2BcX3hvwA/ChatGPT_Image_10_Ιαν_2026,_11_55_29_π.μ..png" alt="Flat lay of failed attempts: therapy card, sobriety app, supplement bottles, handwritten rules with items crossed out" className="w-full h-auto rounded-lg" data-id="element-161" />
              </div>

              <p className="mb-6" data-id="element-162">
                I tried switching from wine to beer thinking it would be easier
                to stop. It wasn't. I tried going cold turkey for 36 hours once.
                The shaking, the cramps, the overwhelming panic—I thought I was
                dying. I was back to drinking before the second day was over.
              </p>

              <p className="mb-6" data-id="element-163">
                I spent hundreds on supplements. Kudzu. Milk thistle.
                B-vitamins. I took them religiously while drinking wine. Nothing
                changed.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-164">
                I was exhausted. Financially drained. Emotionally destroyed.
              </p>

              <p className="mb-8" data-id="element-165">And I was running out of hope.</p>

              <p className="mb-8 italic text-gray-700" data-id="element-166">
                If this sounds familiar, keep reading—because what I discovered
                next changed everything.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-167">
                The Conversation That Changed My Life
              </h2>

              <p className="mb-6" data-id="element-168">
                It was my sister-in-law Rachel who finally broke through.
              </p>

              <p className="mb-6" data-id="element-169">
                We were sitting in her backyard after a family dinner. Everyone
                else had gone inside. She handed me a cup of tea and sat down
                next to me in silence for a moment.
              </p>

              {/* IMAGE 4: Two women having intimate conversation in backyard */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-170">
                <img src="https://cdn.magicpatterns.com/uploads/ivE5jD4gCit5MAzygeVjea/ChatGPT_Image_10_Ιαν_2026,_11_55_20_π.μ..png" alt="Two women having an intimate conversation over tea in a backyard with string lights" className="w-full h-auto rounded-lg" data-id="element-171" />
              </div>

              <p className="mb-6" data-id="element-172">Then she said something I'll never forget:</p>

              <p className="mb-6 text-lg italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-173">
                "Sarah, I know what you're going through. And I need you to hear
                me: it's not a willpower problem. It's your nervous system."
              </p>

              <p className="mb-6" data-id="element-174">I stared at her. "What do you mean?"</p>

              <p className="mb-6" data-id="element-175">
                She took a breath. "I've been where you are. The nightly wine.
                The 3 AM wake-ups. The shame. I thought I was weak. But then I
                learned something that changed everything."
              </p>

              <p className="mb-6" data-id="element-176">
                She explained that after years of chronic stress—work pressure,
                parenting, life's constant demands—our bodies get stuck in
                what's called "sympathetic dominance." Our nervous system gets
                locked in fight-or-flight mode. The gas pedal is stuck down and
                the brake pedal has gone silent.
              </p>

              <p className="mb-6" data-id="element-177">
                "By evening," she said, "your body is so overstimulated that
                it's chemically demanding something—anything—to shut off the
                alarm bells. That's not weakness. That's biology."
              </p>

              <p className="mb-6" data-id="element-178">
                I felt tears streaming down my face. Not because I was sad, but
                because for the first time in years, someone was telling me this
                wasn't my fault.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-179">
                "There's a way to fix it," Rachel said quietly. "But it's not
                what you think."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-180">
                Why Everything I Tried Before Was Doomed to Fail
              </h2>

              <p className="mb-6" data-id="element-181">
                Over the next hour, Rachel explained something I'd never heard
                from any therapist, any app, or any AA meeting I'd nervously
                Googled at 2 AM.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-182">
                The reason willpower never worked wasn't because I was weak. It
                was because I was trying to solve a physiological problem with
                psychological tools.
              </p>

              <p className="mb-6" data-id="element-183">
                Here's what's actually happening in your body when you can't
                stop drinking:
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-184">
                The Cortisol-Craving Loop
              </h3>

              <p className="mb-6" data-id="element-185">
                Chronic stress floods your body with cortisol all day long. This
                stress hormone keeps your nervous system locked in emergency
                mode—constantly alert, constantly activated, constantly on edge.
              </p>

              <p className="mb-6" data-id="element-186">
                By the time evening rolls around, your brain is desperate for
                relief from that constant state of alarm. And alcohol? Alcohol
                temporarily forces your nervous system to calm down.
              </p>

              <p className="mb-6" data-id="element-187">
                So your body learns: "Wine = relief from cortisol overload."
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-188">
                It's not a habit. It's not a choice. It's a chemical dependency
                your stressed-out body has developed just to survive.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-189">
                The Sympathetic Dominance Problem
              </h3>

              <p className="mb-6" data-id="element-190">
                Think of your nervous system like a car with two pedals. The
                sympathetic nervous system is the gas pedal (alert, active,
                stressed). The parasympathetic nervous system is the brake pedal
                (calm, relaxed, recovered).
              </p>

              <p className="mb-6" data-id="element-191">
                Most people's nervous systems naturally shift between the two
                throughout the day. Gas pedal during work. Brake pedal in the
                evening.
              </p>

              <p className="mb-6" data-id="element-192">
                But years of chronic stress—combined with nightly drinking—have
                broken that system. Your gas pedal is stuck down. Your brake
                pedal doesn't work anymore.
              </p>

              <p className="mb-8" data-id="element-193">
                Alcohol is the only thing that forces your foot off the gas.
                That's why "just one glass" feels impossible. Your body isn't
                looking for a drink—it's looking for the only emergency brake it
                knows.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-194">
                Why White-Knuckling Doesn't Work
              </h3>

              <p className="mb-6" data-id="element-195">
                When you try to quit through willpower alone, you're asking a
                flooded nervous system to calm itself using thoughts.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-196">
                That's like trying to stop a fire by telling it to stop burning.
              </p>

              <p className="mb-6" data-id="element-197">
                It doesn't matter how motivated you are. It doesn't matter how
                much you love your family. Your body is in a state of
                physiological crisis and it will do whatever it takes to find
                relief.
              </p>

              <p className="mb-8" data-id="element-198">
                Rachel looked at me and said, "That's why every attempt you've
                made has failed. You were trying to fix a nervous system problem
                with discipline. It was never going to work."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-199">
                Then She Told Me About the Solution
              </h2>

              <p className="mb-6" data-id="element-200">
                "I tried something three months ago," Rachel said. "A patch."
              </p>

              <p className="mb-6" data-id="element-201">
                I almost laughed. A patch? After all the things I'd tried, a
                PATCH was supposed to fix this?
              </p>

              <p className="mb-6" data-id="element-202">
                But Rachel wasn't smiling. She was serious.
              </p>

              <p className="mb-6" data-id="element-203">
                "It's not a nicotine patch or anything addictive," she
                explained. "It delivers ingredients that actually calm your
                nervous system. Continuously. For 24 hours."
              </p>

              {/* IMAGE 5: Woman showing discreet patch on upper arm */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-204">
                <img src="https://cdn.magicpatterns.com/uploads/oXi8MQgdXbLKDi3874FUbV/ChatGPT_Image_10_Ιαν_2026,_11_55_22_π.μ..png" alt="Close-up of a discreet transdermal patch on a woman's upper arm" className="w-full h-auto rounded-lg" data-id="element-205" />
              </div>

              <p className="mb-6" data-id="element-206">
                She told me it was designed specifically for people like
                us—high-functioning adults whose drinking is driven by an
                overstimulated stress response, not by addiction in the
                traditional sense.
              </p>

              <p className="mb-6" data-id="element-207">
                "It gives your body what it's been screaming for," she said.
                "Support for your nervous system. The nutrients alcohol has
                depleted. A way to actually calm down without needing wine to do
                it."
              </p>

              <p className="mb-6" data-id="element-208">
                I was skeptical. After so many failed attempts, hope felt
                dangerous.
              </p>

              <p className="mb-6" data-id="element-209">
                But Rachel pulled up her sleeve and showed me a small, discreet
                patch on her upper arm.
              </p>

              <p className="mb-6 text-lg italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-210">
                "I haven't wanted wine in eight weeks," she said. "Not craved
                it. Not white-knuckled my way through an evening. I just...
                don't want it anymore. And I sleep through the night now. No
                more 3 AM panic attacks."
              </p>

              <p className="mb-6" data-id="element-211">
                I looked at her face. She looked different. Calmer. Lighter.
                Present.
              </p>

              <p className="mb-6" data-id="element-212">
                "It's called Glisera," she said. "And if you're ready, I think
                it could change your life."
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-213">
                That night, I ordered it.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-214">
                What Happened in the First Week
              </h2>

              <p className="mb-6" data-id="element-215">
                The package arrived three days later in plain brown packaging.
                No one would ever know what was inside.
              </p>

              <p className="mb-6" data-id="element-216">
                I opened it in my bathroom with shaking hands. Inside was a
                month's supply of patches and simple instructions: apply one
                patch to your upper arm or shoulder blade each morning. Wear it
                for 24 hours. Replace daily.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-217">
                Day 1:
              </h3>

              <p className="mb-6" data-id="element-218">
                I put on the first patch that Thursday morning. It was small,
                thin, and completely invisible under my shirt.
              </p>

              <p className="mb-6" data-id="element-219">Honestly? I didn't feel anything dramatic.</p>

              <p className="mb-6" data-id="element-220">
                But that evening, something was different. It was 7 PM—my usual
                "wine o'clock." I was making dinner, and normally by that point
                I'd already have a glass poured.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-221">
                But the screaming urge wasn't there. It was more like...
                background noise. Like someone had turned the volume down from a
                10 to maybe a 6.
              </p>

              <p className="mb-6" data-id="element-222">
                I didn't drink that night. Not out of willpower. I just didn't
                feel desperate for it.
              </p>

              <p className="mb-8" data-id="element-223">
                I slept restlessly—probably still adjusting—but I didn't wake up
                at 3 AM in a panic. That alone felt like a miracle.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-224">
                Day 2:
              </h3>

              <p className="mb-6" data-id="element-225">
                Friday morning I woke up without the usual fog. My head felt
                clearer than it had in months.
              </p>

              <p className="mb-6" data-id="element-226">
                I changed the patch and went to work. The afternoon was easier.
                The evening was easier.
              </p>

              <p className="mb-6" data-id="element-227">
                That night, I had one glass of wine with dinner. Just one. And I
                didn't finish it.
              </p>

              <p className="mb-6" data-id="element-228">
                My husband noticed. "You okay?" he asked, looking at the
                half-full glass I'd left on the counter.
              </p>

              <p className="mb-8" data-id="element-229">"Yeah," I said. And I meant it.</p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-230">
                Day 3:
              </h3>

              <p className="mb-6" data-id="element-231">
                Saturday was the real test. Weekends were always my worst. No
                work structure. More time at home. More opportunity to drink
                starting at noon.
              </p>

              <p className="mb-6" data-id="element-232">
                But that morning, I woke up at 6 AM naturally. No alarm. No
                panic. Just... awake.
              </p>

              <p className="mb-6" data-id="element-233">
                Emma came into the kitchen around 8. I was making pancakes.
              </p>

              {/* IMAGE 6: Mother and daughter reconnecting - making pancakes together */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-234">
                <img src="https://cdn.magicpatterns.com/uploads/e3yQtaMS9MQYPppszvJuFC/ChatGPT_Image_10_Ιαν_2026,_11_55_24_π.μ..png" alt="Mother and teenage daughter making pancakes together in a bright kitchen, reconnecting" className="w-full h-auto rounded-lg" data-id="element-235" />
              </div>

              <p className="mb-6" data-id="element-236">
                She looked at me for a moment—really looked at me—and said,
                "Mom, you seem different."
              </p>

              <p className="mb-6" data-id="element-237">"Different how?" I asked.</p>

              <p className="mb-6" data-id="element-238">"I don't know. Just... better, I guess."</p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-239">
                I started crying right there over the pancake batter. She hugged
                me. It was the first real hug we'd had in months.
              </p>

              <p className="mb-6" data-id="element-240">
                That night we had a family movie night. Everyone else had wine.
                I had sparkling water with lime.
              </p>

              <p className="mb-8" data-id="element-241">
                And here's the thing: I didn't feel left out. I didn't feel like
                I was missing something. The urge to drink was barely a whisper.
              </p>

              <p className="mb-8 font-bold text-gray-900 text-xl" data-id="element-242">
                The screaming demon that had controlled my evenings for years
                had gone quiet.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-243">
                Day 7:
              </h3>

              <p className="mb-6" data-id="element-244">
                By the end of week one, I felt like a different person.
              </p>

              <p className="mb-6" data-id="element-245">
                I was sleeping through the night—deep, restorative sleep. I'd
                wake up at 6 AM feeling actually rested. No grogginess. No brain
                fog. No shame.
              </p>

              <p className="mb-6" data-id="element-246">
                The constant anxiety that had been my shadow for years had
                lifted. I felt calm. Not numb—truly calm.
              </p>

              <p className="mb-6" data-id="element-247">
                My face looked different in the mirror. Less puffy. Less tired.
                My eyes were clearer.
              </p>

              {/* IMAGE 7: Woman looking at herself in mirror - transformation */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-248">
                <img src="https://cdn.magicpatterns.com/uploads/tRUsEjhShUeg9oBWpqXoGX/ChatGPT_Image_10_Ιαν_2026,_11_55_26_π.μ..png" alt="Woman looking at herself in a mirror, noticing positive transformation" className="w-full h-auto rounded-lg" data-id="element-249" />
              </div>

              <p className="mb-6 font-bold text-gray-900" data-id="element-250">
                But the biggest change? The mental obsession was gone.
              </p>

              <p className="mb-6" data-id="element-251">
                I wasn't spending all day thinking about whether I'd drink that
                night. I wasn't making rules or bargaining with myself. I wasn't
                white-knuckling my way through each evening.
              </p>

              <p className="mb-8" data-id="element-252">I was just... living. Present. Free.</p>

              <p className="mb-12 text-xl font-bold text-gray-900" data-id="element-253">
                By week two, my daughter was looking at me at breakfast again.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-254">
                This isn't just my story. Thousands of women are experiencing
                the same transformation.
              </h2>

              <TestimonialBox testimonials={testimonials} data-id="element-255" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-256">
                Here's What Makes This Different From Everything Else You've
                Tried
              </h2>

              <p className="mb-6" data-id="element-257">
                The patch is called Glisera, and it's specifically designed for
                high-functioning adults whose drinking is driven by chronic
                stress and nervous system dysregulation.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-258">
                It's not a medication. It's not addictive. And it doesn't
                require you to admit you're an "alcoholic" or attend meetings or
                tell anyone what you're doing.
              </p>

              <p className="mb-8" data-id="element-259">
                It's discreet, private, and science-backed support for your
                overstimulated nervous system.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-260">
                Here's what's actually in it:
              </p>

              <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-261">
                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-262">
                  Kudzu Extract
                </h3>
                <p className="mb-4" data-id="element-263">
                  Used in traditional medicine for over 1,000 years to reduce
                  alcohol cravings. Clinical studies show it helps regulate
                  dopamine response and reduces the compulsion to drink. It
                  doesn't make you sick if you do drink—it simply makes you want
                  it less.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-264">
                  High-Dose B-Vitamins (B1, B6, B12) + Magnesium
                </h3>
                <p className="mb-4" data-id="element-265">
                  Alcohol rapidly depletes these essential nutrients. Without
                  them, your nervous system can't produce calming
                  neurotransmitters like GABA or regulate stress hormones like
                  cortisol. The patch replenishes these nutrients continuously,
                  giving your brain what it needs to feel calm naturally.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-266">
                  Adaptogenic Herb Blend (Ashwagandha, Rhodiola, Holy Basil)
                </h3>
                <p data-id="element-267">
                  These herbs have been clinically shown to lower cortisol
                  levels, restore healthy stress response, and activate your
                  parasympathetic nervous system (the "brake pedal"). They help
                  your body shift out of fight-or-flight mode and into
                  rest-and-digest mode—without alcohol.
                </p>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-268">
                The Transdermal Advantage
              </h3>

              <p className="mb-6" data-id="element-269">
                Here's why the patch works when pills and supplements don't:
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-270">
                Alcohol damages your gut lining. That means even if you're
                taking supplements by mouth, your body can't absorb them
                properly.
              </p>

              <p className="mb-6" data-id="element-271">
                But transdermal delivery (through the skin) bypasses your
                digestive system entirely. The ingredients are absorbed directly
                into your bloodstream and delivered continuously for 24 hours.
              </p>

              <p className="mb-8" data-id="element-272">
                No spikes. No crashes. Just steady, reliable support.
              </p>

              <p className="mb-8" data-id="element-273">
                It works while you work. While you sleep. While you're living
                your life.
              </p>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 my-8" data-id="element-274">
                <p className="text-blue-900 font-bold text-lg" data-id="element-275">
                  Over 89% of users report significantly reduced cravings within
                  the first 7 days.
                </p>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-276">
                "But I've Tried Everything... How Is This Different?"
              </h2>

              <p className="mb-6" data-id="element-277">
                I know what you're thinking. I thought the same thing.
              </p>

              <p className="mb-6 italic text-gray-700" data-id="element-278">
                "I've tried supplements before. They didn't work."
                <br data-id="element-279" />
                "I've tried therapy. I kept drinking."
                <br data-id="element-280" />
                "I've tried apps and books and programs. Nothing stuck."
              </p>

              <p className="mb-6 font-bold text-gray-900 text-lg" data-id="element-281">
                Here's why this is different:
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-282">
                Everything else you tried was treating the symptoms.
              </p>

              <ul className="space-y-3 mb-8 list-none pl-0" data-id="element-283">
                <li className="flex items-start" data-id="element-284">
                  <span className="text-red-500 mr-2" data-id="element-285">✗</span>
                  <span data-id="element-286">
                    Apps track your drinking but don't calm your nervous system.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-287">
                  <span className="text-red-500 mr-2" data-id="element-288">✗</span>
                  <span data-id="element-289">
                    Therapy explores your past but doesn't replenish depleted
                    GABA.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-290">
                  <span className="text-red-500 mr-2" data-id="element-291">✗</span>
                  <span data-id="element-292">
                    AA focuses on abstinence but doesn't address cortisol
                    overload.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-293">
                  <span className="text-red-500 mr-2" data-id="element-294">✗</span>
                  <span data-id="element-295">
                    Pills and supplements get destroyed in your damaged gut
                    before they can help.
                  </span>
                </li>
              </ul>

              <p className="mb-8 font-bold text-gray-900 text-xl" data-id="element-296">
                Glisera targets the root cause: your overstimulated nervous
                system.
              </p>

              <p className="mb-8" data-id="element-297">
                When your body gets the support it's been desperately
                lacking—when cortisol regulates, when GABA replenishes, when
                your nervous system can finally shift gears naturally—the
                craving simply fades.
              </p>

              <p className="mb-12 font-bold text-gray-900" data-id="element-298">
                You're not fighting it. You're not white-knuckling it. You're
                not using willpower.
              </p>

              <p className="mb-12 text-xl font-bold text-gray-900" data-id="element-299">
                You just... don't want it anymore.
              </p>

              <div className="bg-gray-50 p-8 rounded-lg my-12" data-id="element-300">
                <h3 className="text-xl font-bold text-gray-900 mb-6 font-sans" data-id="element-301">
                  Common Questions
                </h3>

                <div className="space-y-6" data-id="element-302">
                  <div data-id="element-303">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-304">
                      "Will people know I'm wearing it?"
                    </h4>
                    <p className="text-gray-700" data-id="element-305">
                      No. The patch is small, thin, and flesh-toned. You wear it
                      on your upper arm or shoulder blade—completely hidden
                      under normal clothing. It stays on through showers,
                      workouts, and sleep.
                    </p>
                  </div>

                  <div data-id="element-306">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-307">
                      "What if I'm not ready to quit completely?"
                    </h4>
                    <p className="text-gray-700" data-id="element-308">
                      You don't have to. This isn't an abstinence program. Many
                      people find they can moderate once their nervous system is
                      supported. Others discover they prefer life without
                      alcohol. Either way, you're in control—not the craving.
                    </p>
                  </div>

                  <div data-id="element-309">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-310">
                      "I'm scared to hope again..."
                    </h4>
                    <p className="text-gray-700" data-id="element-311">
                      I understand. After every failed attempt, hope feels
                      dangerous.
                    </p>
                    <p className="text-gray-700 mt-2 font-bold" data-id="element-312">
                      But here's the truth: you didn't fail because you're weak.
                      You failed because you were trying to solve a biological
                      problem with behavioral solutions.
                    </p>
                    <p className="text-gray-700 mt-2" data-id="element-313">
                      This is different. And it comes with a 30-day money-back
                      guarantee. If it doesn't work, you get every penny back.
                      No questions asked.
                    </p>
                    <p className="text-gray-700 mt-2 italic" data-id="element-314">
                      You have nothing to lose except the next 3 AM panic
                      attack.
                    </p>
                  </div>
                </div>
              </div>

              <CTASection variant="primary" data-id="element-315" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-16 mb-6 font-sans" data-id="element-316">
                One Last Thing
              </h2>

              <p className="mb-6" data-id="element-317">
                That Tuesday morning when Emma wouldn't look at me at
                breakfast—that was four months ago.
              </p>

              <p className="mb-6" data-id="element-318">
                This morning, she came into the kitchen, sat down next to me,
                and asked if I wanted to go for a walk after school.
              </p>

              <p className="mb-6" data-id="element-319">
                We walked for an hour. We talked about her friends, her stress
                about exams, her dreams for college.
              </p>

              {/* IMAGE 8: Mother and daughter walking together - happy ending */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-320">
                <img src="https://cdn.magicpatterns.com/uploads/eXDuJs7i6veAqvzjTp6k1m/ChatGPT_Image_10_Ιαν_2026,_11_55_28_π.μ..png" alt="Mother and teenage daughter walking together on a tree-lined street, arms linked, happy" className="w-full h-auto rounded-lg" data-id="element-321" />
              </div>

              <p className="mb-6 font-bold text-gray-900" data-id="element-322">
                She told me she's proud of me.
              </p>

              <p className="mb-8" data-id="element-323">
                I can't describe what that felt like. To have my daughter back.
                To have myself back.
              </p>

              <p className="mb-8 text-xl font-bold text-gray-900" data-id="element-324">
                The shame dies when you take action.
              </p>

              <p className="mb-6" data-id="element-325">
                Your nervous system has been flooded with stress hormones for
                years. It's not your fault you've been using alcohol to cope.
                But now you know there's another way.
              </p>

              <p className="mb-12" data-id="element-326">
                You deserve to feel calm. You deserve to sleep through the
                night. You deserve to be present. You deserve your life back.
              </p>

              <p className="mb-12 font-bold text-gray-900 text-xl" data-id="element-327">
                And it starts with one simple decision.
              </p>

              <CTASection variant="final" data-id="element-328" />
            </div>
          </article>

          {/* Sidebar Column */}
          <aside className="hidden lg:block w-[35%]" data-id="element-329">
            <ProductSidebar data-id="element-330" />
          </aside>
        </div>
      </main>

      <StickyBottomBar data-id="element-331" />
    </div>;
}